import crud from "./_crud";

const actions = crud('employee_work_shift', 'el turno del empleado', 'los turnos de los empleados');

export default actions